<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 bg-mj-gris">

  <!-- Barra superior con logos -->
  <div *ngIf="!isScrolled" class="bg-mj-azul sm:bg-amarillo-200 md:bg-morado-200 lg:bg-amarillo-200">
    <div class="w-full max-w-[1280px] m-auto flex items-center justify-between h-12 md:h-16 py-4 px-2 xl:px-2">
      <a class="w-24 md:w-28 flex flex-wrap" href="https://www.gov.co/" target="_blank">
        <img src="assets/images/logo/logo_gov.png">
      </a>
      <a class="w-36 md:w-48" href="https://www.medellin.gov.co/" target="_blank">
        <img src="assets/images/logo/secre-1.png">
      </a>
    </div>
  </div>

  <!-- Espaciador -->
  <div *ngIf="isScrolled" class="h-20 md:h-18 xl:h-20"></div>

  <!-- Navbar -->
  <div class="bg-mj-azul-1 w-full" [ngClass]="{ 'fixed top-0 left-0 right-0 shadow-lg z-[60]': isScrolled }">

    <div class="w-full max-w-[1280px] m-auto flex items-center justify-between h-16 md:h-18 xl:h-20 py-2 px-2 xl:px-2">

      <!-- Logo Medellín Joven -->
      <a routerLink="/inicio" class="block">
        <img class="w-52 md:w-80" src="assets/images/logo/LOGO MED JOVEN 2025-01.png">
      </a>

      <!-- Botón "Menú" reemplazando ícono hamburguesa (NUEVO) -->
      <button (click)="toggleMenu()"
        class="xl:hidden block bg-mj-morado-2 text-white py-1 px-4 rounded-lg hover:bg-mj-morado-3 transition-all text-sm font-semibold">
        Menú
      </button>

      <!-- Menú desplegable en móviles -->
      <div
        class="bg-mj-morado-1 xl:bg-transparent absolute xl:relative w-full top-16 md:top-16 xl:top-0 z-[55] left-0 right-0 overflow-x-hidden overflow-y-auto max-h-[calc(100vh-4rem)]"
        *ngIf="menuVisible">
        <!-- Botón cerrar (X) solo en móviles -->
        <div class="relative text-end block xl:hidden">
          <button mat-icon-button (click)="toggleMenu()" class="absolute top-2 right-2">
            <mat-icon class="text-white" [svgIcon]="'mdi:close'"></mat-icon>
          </button>
        </div>

        <!-- Buscador solo móviles -->
        <div
          class="relative flex py-4 justify-center items-center w-11/12 sm:w-9/12 md:w-7/12 lg:w-1/3 xl:w-full mx-auto xl:hidden border-b z-50">
          <input type="text" #searchInput id="searchInputSmall"
            class="flex-grow mx-auto my-4 py-2 shadow-lg text-sm text-gray-900 border border-gray-300 rounded-md bg-gray-50 focus:outline-none transition-opacity duration-1000 w-64 xl:w-full"
            placeholder="Escribe la oportunidad de empleo que deseas buscar" (input)="validateInput(searchInput.value)">
          <button [disabled]="!isInputValid || !searchInput.value"
            (click)="handleRedirectSearchMobile(searchInput.value)"
            class="bg-mj-azul w-[30px] h-[30px] p-2 m-1 flex justify-center items-center shadow-md rounded-full ml-2 disabled:bg-mj-gris-4">
            <mat-icon class="icon-size-5 text-white font-black search__icon" matPrefix
              [svgIcon]="'mdi:magnify'"></mat-icon>
          </button>
        </div>

        <!-- Menú de navegación -->
        <ul
          class="sub-header__list flex flex-col xl:flex-row m-auto w-64 xl:w-full justify-center xl:justify-center text-white xl:text-black raleway-600 z-[55]">

          <!-- Inicio - CON exact:true porque no tiene rutas hijas -->
          <li class="py-4">
            <a routerLink="/inicio" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              [routerLinkActiveOptions]="{ exact: true }"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Inicio
            </a>
          </li>

          <!-- Empleo - SIN exact:true para que marque también las rutas hijas -->
          <li class="py-4">
            <a routerLink="/empleo" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Empleo
            </a>
          </li>

          <!-- Formación - SIN exact:true para que marque también las rutas hijas -->
          <li class="py-4">
            <a routerLink="/formacion" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Formación
            </a>
          </li>

          <!-- Qué hay pa hacer - SIN exact:true para que marque también las rutas hijas -->
          <li class="py-4">
            <a routerLink="/que-hay-pa-hacer" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Qué hay pa hacer
            </a>
          </li>

          <!-- Servicios - SIN exact:true para que marque también las rutas hijas -->
          <li class="py-4">
            <a routerLink="/servicios" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Servicios
            </a>
          </li>

          <!-- Submenú Conócenos -->
          <li class="py-4 flex justify-center">
            <button [matMenuTriggerFor]="menu"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all">
              Conócenos <span class="inline-block rotate-90">></span>
            </button>

            <mat-menu #menu="matMenu" class="bg-mj-azul-6">
              <a href="https://www.medellin.gov.co/es/secretaria-juventud/" target="_blank" class="block py-2 px-4 hover:bg-gray-100" 
                (click)="closeMenu()">La Secretaría</a>
              <a routerLink="/observatorio" class="block py-2 px-4 hover:bg-gray-100" 
                (click)="closeMenu()">Observatorio</a>

              <a routerLink="/desparchadero" class="block py-2 px-4 hover:bg-gray-100" 
                (click)="closeMenu()">Desparchadero</a>
            </mat-menu>
          </li>

          <!-- Salvavidas -->
          <li class="py-4">
            <a href="https://www.medellin.gov.co/satmed/nuevo-caso" target="_blank"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all"
              (click)="closeMenu()">
              Salvavidas
            </a>
          </li>

          <!-- Inicia sesión - CON exact:true -->
          <li class="py-4 px-2 text-center flex justify-center">
            <a routerLink="/iniciar-sesion" routerLinkActive="bg-mj-morado-2 text-white rounded-lg"
              [routerLinkActiveOptions]="{ exact: true }"
              class="block text-center py-1 px-4 hover:bg-mj-morado-2 hover:text-white hover:rounded-lg transition-all m-auto"
              *ngIf="!authService.getToken()" (click)="closeMenu()">
              Inicia sesión
            </a>

            <buton-user-profile class="m-auto" [ngClass]="{ hidden: !authService.getUser() }"></buton-user-profile>
          </li>

        </ul>

      </div>
    </div>
  </div>
</div>